<template>
	<div class="personHome">
		<!-- 左侧产品列表 -->
		<div class="psLeftContent">
			<!-- 我的产品 -->
			<div class="item w100">
				<div class="text bd10 p3">
					<div class="sTitle d-flex a-center j-sb">
						 <h3 class="font20">{{$t('adminMenu.product')}}</h3>
					</div>
					<div class="table font-light line-mn">
						<dl>
							<dt class="d-flex">
								<span>{{$t('admin.productName')}}</span>
								<span>{{$t('admin.productType')}}</span>
								<!-- <span>{{$t('admin.purchasingDate')}}</span>
								<span>{{$t('admin.versionNo')}}</span>
								<span>{{$t('admin.downloadAccess')}}</span>
								<span>{{$t('admin.documentAccess')}}</span> -->
								<span  class="d-flex j-center a-center">{{$t('commom.view')}}</span>
							</dt>
							<dd class="d-flex"  v-for="(item, index) in productVoList" :key="index">
								<span v-if="item.isIpProject" @click="goToPage('/ipProductDetail?id='+item.id)" class="nowrap2"><a class="link pointer" :title="item.productName">{{item.productName}}</a></span>
								<span v-else @click="goToPage('/productDirectory?productId='+item.id)" class="nowrap2"><a class="link pointer" :title="item.productName">{{item.productName}}</a></span>
								<span>{{item.productType}}</span>
								<!-- <span>{{item.payDate}}</span>
								<span>{{item.version ? item.version : $t('commom.isnull')}}</span>
								<span class="d-flex j-center a-center">
									<img src="@/assets/Icons/allow.png" class="a" alt="">
									<img src="@/assets/Icons/prohibit.png" class="p hidden" alt="">
								</span>
								<span class="d-flex j-center a-center">
									<img src="@/assets/Icons/allow.png" class="a" alt="">
									<img src="@/assets/Icons/prohibit.png" class="p hidden" alt="">
								</span> -->
								<span v-if="item.isIpProject" class="d-flex j-center a-center" @click="goToPage('/ipProductDetail?id='+item.id)" >
									<a class="d link pointer"></a>
								</span>
								<span v-else class="d-flex j-center a-center" @click="goToPage('/productDirectory?productId='+item.id)" >
									<a class="d link pointer"></a>
								</span>
							</dd>
						</dl>
					</div>
				</div>
				<!-- 分页 -->
				<div class="pagination">
					 <el-pagination
						   @current-change="handleCurrentChange"
						   :page-size="10"
						   layout="prev, pager, next"
						   :total="total">
					</el-pagination>
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
export default {
  name: 'MyProduct',
  components: {
    
  },
  data() {
    return {
		// 产品
		productVoList: [],
		// 分页
		pagination: {
			pageNo: 1,
			pageSize: 10
		},
		// 数量
		total: 0
	}
  },
  
  created() {
  	  // 获取产品
  	  this.getProductVoList();
  },
  
  methods: {
	  // 获取产品
	  getProductVoList() {
		  this.$axios.post('member/productPage', this.pagination)
		  .then(res => {
			  this.productVoList = res.data.list;
			  this.total = res.data.total;
		  })
		  .catch(err => {})
	  },
	  
	  // 页面跳转，新窗口打开
	  goToPageOpen(path, param={}) {
		  let routeUrl = this.$router.resolve({
			  path: path,
			  query: param
		   });
		   window.open(routeUrl.href, '_blank');
	  },
	  
	  // 点击翻页
	  handleCurrentChange(current) {
		  this.pagination.pageNo = current;
		  // 更新
		  this.getProductVoList();
	  }
  }
}
</script>

<style lang="less" scoped>
	.personHome{
		
		.psLeftContent{
			width: 100%;
			.toPage{
				margin-left: .15rem;
				input{
					width: .4rem;
					height: .4rem;
					border-radius: 5px;
					background: #fff;
					text-align: center;
					margin: 0 5px;
					padding: 0 5px;
				}
			}
			.item{
				width: 50%;
				margin-bottom: .2rem;
				&.w100{
					width: 100%;
					dd:hover,dd:hover a{
						color: #2657db;
					}
				}
			}
			.table{
				dl{
					dt,dd{
						padding: .22rem 0;
					}
					dt{
						background: #f2f5fa;
						border-radius: 5px;
						span:nth-of-type(1) {
							padding-left: .15rem;
						}
					}
					dd{
						&:not(:last-child) {
							border-bottom: solid 1px #eee;
						}
						span:nth-of-type(1) {
							position: relative;
							padding-left: .2rem;
							&:after{
								content: "";
								position: absolute;
								left: 0;
								top: .1rem;
								width: .04rem;
								height: .04rem;
								background: #2657db;
							}
						}
					}
					span{
						.a{
							width: .2rem;
						}
						.p{
							width: .14rem;
						}
						&:nth-of-type(1) {
							width: calc(80% - 1rem);
						}
						&:nth-of-type(2) {
							width: 20%;
						}
						&:nth-of-type(3) {
							width: 12%;
						}
						&:nth-of-type(4) {
							width: 12%;
						}
						&:not(:last-child) {
							padding-right: .2rem;
						}
						&:last-child,
						&:nth-of-type(5),
						&:nth-of-type(6){
							width: 1rem;
						}
						.d{
							width: .19rem;
							height: .14rem;
							background: url(@/assets/Icons/look.png) no-repeat center/100% 100%; 
							&:hover{
								background-image: url(@/assets/Icons/lookBlue.png);
							}
						}
					}
				}
			}
		}
		@media (max-width: 1200px) {
			.psLeftContent{
				.table{
					dl{
						span{
							&:nth-of-type(1) {
								width: 4rem;
								flex: 1 1 auto;
							};
							&:nth-of-type(2),
							&:nth-of-type(3),
							&:nth-of-type(4) {
								width: 1.3rem;
							}
							&:last-child{
								width: 1rem;
							}
						}
					}
				}
			}
		}
		@media (max-width: 640px) {
			padding: .2rem;
		}
	}
</style>
